import { FC } from 'react'
import { useAppSelector } from '../../../redux'
import { LessonResourceListItem } from '..'
import { StyledLessonResourceList } from '.'

const LessonResourceList: FC = () => {
  const { lesson, tab, loading } = useAppSelector((state) => state.course)

  if (tab !== 'resources' || loading) {
    return null
  }

  return (
    <StyledLessonResourceList>
      {lesson?.additionalFiles?.map((resource, index) => {
        return <LessonResourceListItem resource={resource} key={index} />
      })}
    </StyledLessonResourceList>
  )
}

export default LessonResourceList
